import clienteAxios from "../config/axios";

export async function getAllOPD() {
    return clienteAxios.get('/opd');
}

export async function addOPD(opd, products, imputaciones, tareas) {
    return clienteAxios.post('/opd', { opd, products, imputaciones, tareas });
}

export async function updateOPD(id, updates, products, imputaciones, tareas) {
    return clienteAxios.put('/opd', { id, updates, products, imputaciones, tareas });
}

export async function deleteOPD(nroFor, id, state) {
    return clienteAxios.delete(`/opd/${nroFor}/${id}/${state}`);
}

export async function getOPDByFilter(filtros) {
    return clienteAxios.post('/opd/filter', filtros);
}

export async function getOPDByUserId(userId, filtros) {
    return clienteAxios.get(`/opd/${userId}${filtros || ''}`);
}

export async function getOPDByCodNroFor(tDocCodFor, tDocNroFor) {
    return clienteAxios.get(`/getOPDByCodNroFor/${tDocCodFor}/${tDocNroFor}`);
}
